import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const EMPTY = { title: "", description: "", category: "", video_url: "" };
const inputCls = "w-full rounded-xl border-2 border-purple-500/30 bg-black/40 px-3 py-2.5 text-white outline-none focus:border-[var(--km-pink)]";

export const PortfolioForm = ({ open, initial, onClose, onSave }) => {
  const [form, setForm] = useState(initial || EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await onSave(form); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent dir="rtl" className="max-h-[90vh] overflow-y-auto border-purple-500/30 bg-[var(--km-bg2)] text-white" data-testid="portfolio-form-dialog">
        <DialogHeader className="text-right sm:text-right">
          <DialogTitle className="font-display text-2xl">{initial ? "تعديل الفيديو" : "إضافة فيديو جديد"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4" data-testid="portfolio-form">
          <label className="block">
            <span className="mb-1 block text-sm font-bold">عنوان الفيديو *</span>
            <input className={inputCls} value={form.title} onChange={set("title")} required maxLength={150} data-testid="portfolio-title-input" />
          </label>
          <label className="block">
            <span className="mb-1 block text-sm font-bold">رابط الفيديو * (YouTube أو Vimeo أو رابط/كود Embed)</span>
            <textarea className={`${inputCls} min-h-[80px] text-left`} dir="ltr" value={form.video_url} onChange={set("video_url")} required
              placeholder="https://www.youtube.com/watch?v=..." data-testid="portfolio-url-input" />
          </label>
          <label className="block">
            <span className="mb-1 block text-sm font-bold">التصنيف</span>
            <input className={inputCls} value={form.category} onChange={set("category")} maxLength={60} placeholder="مثلاً: إعلانات سوشيال" data-testid="portfolio-category-input" />
          </label>
          <label className="block">
            <span className="mb-1 block text-sm font-bold">وصف قصير</span>
            <textarea className={`${inputCls} min-h-[70px]`} value={form.description} onChange={set("description")} maxLength={1000} data-testid="portfolio-description-input" />
          </label>
          <div className="flex gap-2 pt-2">
            <button type="submit" disabled={busy} className="font-head inline-flex items-center gap-2 rounded-full bg-[var(--km-pink)] px-6 py-2.5 font-bold disabled:opacity-60" data-testid="portfolio-save-btn">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} حفظ
            </button>
            <button type="button" onClick={onClose} className="rounded-full border border-purple-500/30 px-6 py-2.5" data-testid="portfolio-cancel-btn">إلغاء</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
